import { Button, Form, Badge } from '@themesberg/react-bootstrap';
import React from 'react'
import ImageUpload from './ImageUpload';

export const AddPairTicketTableRow = (props) => {
  const { rIndex, last5Numbers, amount, images, onDelete, onChangeAmount, onChangeLast5Numbers, onChangeImage } = props;
  return (
    <tr className="table-success">
      <td className="text-center">
        {rIndex + 1}
        <Badge bg="success" className="ms-2">Cặp</Badge>
      </td>
      <td className="text-center">
        <div className="d-flex align-items-center justify-content-center">
          <span className="me-1" style={{ color: '#999' }}>x</span>
          <Form.Control 
            required 
            type="text" 
            maxLength={5}
            style={{ width: '100px' }}
            defaultValue={last5Numbers} 
            placeholder="5 số cuối" 
            onInput={(evt) => {
              evt.target.value = evt.target.value.replace(/\D/g, '').slice(0, 5)
            }}
            onChange={(evt) => onChangeLast5Numbers(rIndex, evt.target.value)} 
          />
          <span className="ms-2 text-muted" style={{ fontSize: '12px' }}>
            (10 vé: 0{last5Numbers || 'xxxxx'} - 9{last5Numbers || 'xxxxx'})
          </span>
        </div>
      </td>
      <td className="text-center">
        <Form.Control required type="number" defaultValue={`${amount}`} placeholder="SL mỗi số" onChange={(evt) => onChangeAmount(rIndex, parseInt(evt.target.value))} />
      </td>
      <td className="text-center">
        <ImageUpload value={images} onChange={(payload) => onChangeImage(rIndex, payload)} />
      </td>
      <td className="text-center">
        <Button variant='danger' onClick={() => onDelete(rIndex)}>
          Xóa
        </Button>
      </td>
    </tr>
  );
};
